import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.language.edit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_LANGUAGE_ASYNC: `${uid}.saveLanguageAsync`,
    SAVE_LANGUAGE_SUCCESS: `${uid}.saveLanguageSuccess`,
    SAVE_LANGUAGE_FAILURE: `${uid}.saveLanguageFailure`,
    UPLOAD_LOGO_ASYNC: `${uid}.uploadLogoAsync`,
    UPLOAD_LOGO_SUCCESS: `${uid}.uploadLogoSuccess`,
    UPLOAD_LOGO_FAILURE: `${uid}.uploadLogoFailure`,
    CREATE_LANGUAGE: `${uid}.createLanguage`
};

export { ActionTypes };
